import React, { useState, useEffect } from "react";
import { isDuplicateLine, setLineVariant, variantOfDetail } from "../variants";
import LineVariantSelect from "../LineVariantSelect";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Plus,
  Minus,
  Trash2,
  RotateCcw,
  Check,
} from "feather-icons-react/build/IconComponents";
import "../../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermColumns,
  TermStatusBar,
} from "../terminal/TerminalChrome";
import toast from "react-hot-toast";
import { ProductClass } from "../../../core/json/Product";
import { getUnitList } from "../../../services/MasterApiServices";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import {
  getStockByBranch,
  addEditStock,
} from "../../../services/StockApiServices";
import { InvStockAdjustment } from "../../../core/json/invStockAdjust";
import { InvStockAdjustmentDetail } from "../../../core/json/invStockAdjustDetail";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchSettings,
} from "../../../redux/userSetting";

const StockAdjustmentModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      date: dayjs().format("YYYY-MM-DD"),
    },
    mode: "onBlur",
  });
  const { formatedproductList } = useSelector((state) => state.usersetting);
  const [unitData, setunitData] = useState([]);
  const [products, setProducts] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const dispatch = useDispatch();
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [selectedType, setSelectedType] = useState(0);

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
  }, []);

  const { productList, unitList, settingList } = useSelector(
    (state) => state.usersetting
  );
  console.log("formatedproductList", formatedproductList);

  const handleIncrease = (index) => {
    const currentQuantity = getValues(`items[${index}].adjQuantity`);
    const newQuantity = Number(currentQuantity || 0) + 1;
    setValue(`items[${index}].adjQuantity`, newQuantity);
  };
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const handleDecrease = (index) => {
    const currentQuantity = getValues(`items[${index}].adjQuantity`);
    const newQuantity = Number(currentQuantity || 1) - 1;
    setValue(`items[${index}].adjQuantity`, newQuantity);
  };

  const type = [
    { value: 0, label: "Stock Adjustment" },
    { value: 1, label: "Damage" },
    { value: 2, label: "Wastage" },
  ];

  const handleUnitList = async () => {
    try {
      const formattedUnit = unitList?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setLineVariant(setValue, index, null);
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(`items[${index}].code`, productData?.code || 0);
      // setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].price`, productData?.cost || 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.find(
        (product) => product.guid === guid
      );
      return filteredData;
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  }

  // Fetch purchase invoices data
  const handleEntryNo = async () => {
    try {
      const response = await getStockByBranch(branch);
      const stockData = response?.data || [];
      console.log("stockData", stockData);

      const maxno =
        stockData?.length > 0
          ? stockData
              ?.map((data) => parseInt(data.no.replace(/\D/g, "")))
              ?.reduce((max, num) => Math?.max(max, num), 0)
          : 0;
      let counter = maxno + 1;
      console.log("counter", counter);
      setValue(`no`, counter);
    } catch (error) {
      console.error(
        "Failed to fetch stock adjustments",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleAddRow = () => {
    append({
      batch: "0",
      baseQuantity: 0,
      adjQuantity: 0,
      unit: "",
      product: null,
    });
  };
  useEffect(() => {
    if (mode === "add") {
      handleEntryNo();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }
    }
    // handleProductsList();
    handleUnitList();
  }, []);

  function resetmodal() {
    if (mode === "edit" && data) {
      const resetData = {
        no: data.no,
        remarks: data.remarks,
        type: data.type,
        date: dayjs(data.date),
        items: data?.stockAdjustmentDetails?.map((detail) => ({
          ...variantOfDetail(detail),
          product: detail?.product?.guid,
          batch: detail?.batch,
          unit: detail.unit?.guid,
          baseQuantity: detail.baseQuantity,
          adjQuantity: detail.adjQuantity,
        })),
      };

      // Reset the form with the structured data
      reset(resetData);
    } else {
      reset();
      handleEntryNo();
    }
  }
  useEffect(() => {
    resetmodal();
  }, [data, setValue]);

  async function getUnitByGuid(guid) {
    const filteredData = unitList?.filter((unit) => unit.guid === guid);
    return filteredData[0];
  }

  async function getProductByGuid(guid) {
    const filteredData = productList?.filter(
      (product) => product.guid === guid
    );
    return filteredData[0];
  }

  const handleFormSubmit = async (formdata) => {
    console.log("inside form submit");
    console.log(formdata, "formdata-----");
    const objStockAdj = new InvStockAdjustment();
    if (mode === "edit") {
      console.log("edit mode on--------");
      console.log(data.guid, "data.guid");
      objStockAdj.guid = data.guid;
      objStockAdj.id = data.id;
    }
    objStockAdj.branch = branch;
    console.log(formdata.date, "date");
    objStockAdj.date = formdata.date
      ? dayjs(formdata.date).format("YYYY-MM-DDTHH:mm:ss")
      : null;
    objStockAdj.type = formdata.type;
    objStockAdj.updatedUser = `{${userId?.id}}`;
    // objStockAdj.createdUser = `{${userId?.id}}`;
    objStockAdj.remarks = formdata.remarks || "";

    objStockAdj.no = formdata.no ? String(formdata.no) : "0";

    const detailObj = formdata?.items?.map((e) => {
      console.log("Processing item:", e);
      let product;
      const productValue = e.product || e.product.value;
      console.log("productValue", productValue);
      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList.find((item) => item.guid == e.unit);

      let dedQty, addQty, baseQuantity, adjQuantity;
      baseQuantity = Number(e.baseQuantity) || 0;
      adjQuantity = Number(e.adjQuantity) || 0;
      // compare the parsed numbers: the inputs hold strings, and "10" > "9"
      // is false as text, which flipped add/deduct into negative quantities
      if (formdata.type === 0 && baseQuantity > adjQuantity) {
        dedQty = baseQuantity - adjQuantity;
        addQty = 0;
      } else if (formdata.type === 0 && baseQuantity < adjQuantity) {
        addQty = adjQuantity - baseQuantity;
        dedQty = 0;
      } else {
        dedQty = 0;
        addQty = 0;
      }
      const detail = {
        product,
        variantID: e.variantID || null,
        unit,
        batch: e.batch,
        adjQuantity,
        baseQuantity,
        dedQty,
        addQty,
      };
      console.log("Detail object constructed:", detail);

      return detail;
    });
    objStockAdj.stockAdjustmentDetails = detailObj;
    try {
      console.log(objStockAdj, "-------------------objStockAdj");
      const response = await addEditStock(objStockAdj);
      // success is a literal true (G-2) - a 200 "false" is a failure
      if (response?.data !== true) {
        toast.error(response?.data?.Message || "Not saved - please try again");
      } else {
        toast.success("Success");
        handleRefresh();
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one row entry is required");
    }
  }
  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const menuPortalTarget = menuHost;
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen, More row, visible columns
  const chrome = useTerminalChrome("stockAdjustment", {
    batch: true,
  });
  const typeLabel = type.find((t) => t.value === watch("type"))?.label;
  const docDate = watch("date");
  const qtyTotal = (fields || []).reduce(
    (sum, f, i) => sum + (Number(watch(`items[${i}].adjQuantity`)) || 0),
    0
  );

  return (
    <div>
      <div
        className="modal fade show si-term si-term--txn"
        data-si-theme={chrome.theme}
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <form
              className="si-form"
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              <div className="si-grid">
                <div className="si-left">
                  {/* ============ COMMAND BAR ============ */}
                  <TermCmdBar
                    chrome={chrome}
                    title="Stock Adjustments"
                    docNo={watch("no")}
                    state={
                      mode === "edit"
                        ? { key: "edit", label: "Editing" }
                        : { key: "new", label: "New" }
                    }
                    onBack={handleClose}
                  />

                  {/* ============ HEADER FIELDS ============ */}
                  <section className="si-strip">
                    <div className="si-strip-row si-strip-row--auto">
                      <div className="si-fld">
                        <label>Entry No.</label>
                        <input
                          type="text"
                          className="si-in si-in--mono"
                          placeholder="—"
                          {...register("no")}
                          required
                          //disabled
                        />
                      </div>
                      <div className="si-fld">
                        <label>
                          Date <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name="date"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              value={value ? dayjs(value) : dayjs()}
                              format="DD-MM-YYYY"
                              onChange={(date) =>
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                )
                              }
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>
                          Type <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name={`type`}
                          render={({ field: { onChange, value } }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={type}
                              value={type?.find(
                                (type) => type?.value === value
                              )}
                              onChange={(selectedOption) => {
                                setSelectedType(selectedOption.value);
                                onChange(selectedOption.value);
                              }}
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                              required
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld si-fld--wide">
                        <label>Remarks</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Note for this adjustment"
                          {...register("remarks")}
                        />
                      </div>
                    </div>
                  </section>

                  {/* ============ LINES ============ */}
                  <section className="si-lines">
                    <TermColumns
                      chrome={chrome}
                      columns={[{ key: "batch", label: "Batch" }]}
                    >
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={handleAddRow}
                      >
                        <Plus />
                        <span>Add line</span>
                      </button>
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={() => resetmodal()}
                      >
                        <RotateCcw />
                        <span>Reset</span>
                      </button>
                    </TermColumns>

                    <div className="si-tablewrap">
                      <table
                        className="si-table"
                        style={{
                          minWidth: `${chrome.tableWidth(684, {
                            batch: 80,
                          })}px`,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "240px" }}>
                              Item <span className="si-req">*</span>
                            </th>
                            <th style={{ width: "70px" }}>
                              Unit <span className="si-req">*</span>
                            </th>
                            <th
                              className={chrome.colClass("batch")}
                              style={{ width: "80px" }}
                            >
                              Batch
                            </th>
                            <th className="n" style={{ width: "100px" }}>
                              Current Qty <span className="si-req">*</span>
                            </th>
                            <th style={{ width: "150px" }}>
                              {(() => {
                                let content = "";
                                if (selectedType === 0) {
                                  content = "New Qty";
                                } else if (selectedType === 1) {
                                  content = "Damage Qty";
                                } else if (selectedType === 2) {
                                  content = "Wastage Qty";
                                } else {
                                  content = "Unknown Type";
                                }
                                return content;
                              })()}
                              <span className="si-req">*</span>
                            </th>
                            <th
                              style={{ width: "44px" }}
                              aria-label="Line actions"
                            />
                          </tr>
                        </thead>
                        <tbody>
                          {fields &&
                            fields?.map((field, index) => {
                              return (
                                <tr className="si-line" key={field.id}>
                                  <td data-label="Description">
                                    <Controller
                                      control={control}
                                      name={`items[${index}].product`}
                                      rules={{
                                        required: "Product is required",
                                        validate: () => {
                                          const isDuplicate = isDuplicateLine(watch("items"), index);
                                          return (
                                            !isDuplicate ||
                                            "Duplicate product selected!"
                                          );
                                        },
                                      }}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          className="si-itemsel"
                                          placeholder="Item name or code"
                                          options={formatedproductList}
                                          value={formatedproductList?.find(
                                            (option) => option.value === value
                                          )}
                                          onChange={(selectedOption) => {
                                            onChange(selectedOption.value);
                                            handleEachProductfetch(
                                              selectedOption,
                                              index
                                            );
                                          }}
                                          menuPortalTarget={menuPortalTarget}
                                          menuPosition="fixed"
                                          styles={siSelectStyles}
                                        />
                                      )}
                                    />
                                    <LineVariantSelect
                                      product={productList?.find((p) => p.guid === watch(`items[${index}].product`))}
                                      value={watch(`items[${index}].variantID`)}
                                      onChange={(v) => setLineVariant(setValue, index, v)}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.product && (
                                        <span className="si-err">
                                          {errors.items[index].product.message}
                                        </span>
                                      )}
                                  </td>
                                  <td data-label="Unit">
                                    <Controller
                                      control={control}
                                      name={`items[${index}].unit`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          className="si-unitsel"
                                          placeholder="—"
                                          options={unitData}
                                          value={unitData?.find(
                                            (option) => option.value === value
                                          )}
                                          onChange={(selectedOption) => {
                                            onChange(selectedOption.value);
                                          }}
                                          isDisabled={true}
                                        />
                                      )}
                                    />
                                  </td>

                                  <td className={chrome.colClass("batch")}>
                                    <input
                                      type="text"
                                      className="si-cellin si-cellin--text si-cellin--ro"
                                      {...register(`items[${index}].batch`)}
                                      disabled
                                    />
                                  </td>

                                  <td className="n">
                                    <input
                                      type="text"
                                      inputMode="decimal"
                                      className="si-cellin"
                                      {...register(
                                        `items[${index}].baseQuantity`,
                                        {
                                          required: "Quantity is required",
                                          validate: (value) =>
                                            (!isNaN(value) && value > 0) ||
                                            "Quantity must be a positive number",
                                        }
                                      )}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.baseQuantity && (
                                        <span className="si-err">
                                          {
                                            errors.items[index].baseQuantity
                                              .message
                                          }
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <div className="si-stepper">
                                      <span
                                        className="si-rowbtn"
                                        onClick={() => handleDecrease(index)}
                                      >
                                        <Minus />
                                      </span>
                                      <input
                                        type="text"
                                        className="si-cellin"
                                        defaultValue={1}
                                        {...register(
                                          `items[${index}].adjQuantity`,
                                          {
                                            required:
                                              "Adjustment Quantity is required",
                                            validate: (value) =>
                                              (!isNaN(value) && value > 0) ||
                                              "Adjustment Quantity must be a positive number",
                                          }
                                        )}
                                      />
                                      <span
                                        className="si-rowbtn"
                                        onClick={() => handleIncrease(index)}
                                      >
                                        <Plus />
                                      </span>
                                    </div>
                                    {errors.items &&
                                      errors.items[index]?.adjQuantity && (
                                        <span className="si-err">
                                          {
                                            errors.items[index].adjQuantity
                                              .message
                                          }
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <div className="si-rowacts">
                                      <Link
                                        to="#"
                                        className="si-rowbtn si-rowbtn--del confirm-text"
                                        title="Remove line"
                                        aria-label="Remove line"
                                        onClick={(index) => handleRemove(index)}
                                      >
                                        <Trash2 />
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {fields?.length === 0 && (
                        <div className="si-empty">
                          <p className="big">No lines yet</p>
                          <p>Press Add line to start the adjustment.</p>
                        </div>
                      )}
                    </div>

                    <div className="si-lines-foot">
                      <span>
                        Lines <b>{fields?.length}</b>
                      </span>
                      <span>
                        Qty <b>{qtyTotal}</b>
                      </span>
                    </div>
                  </section>

                  {/* ============ STATUS BAR ============ */}
                  <TermStatusBar
                    context={[
                      typeLabel,
                      docDate ? dayjs(docDate).format("DD-MM-YYYY") : null,
                    ]}
                  />
                </div>

                {/* ============ RAIL ============ */}
                <aside className="si-rail">
                  <div className="si-rail-scroll">
                    <div className="si-card">
                      <div className="si-card-h">
                        <span>Document</span>
                        <span className="r">
                          {docDate ? dayjs(docDate).format("DD-MM-YYYY") : ""}
                        </span>
                      </div>
                      <div className="si-party">
                        <div className="nm">
                          {typeLabel || "No type selected"}
                        </div>
                        <div className="meta">
                          {typeLabel
                            ? `Entry ${watch("no") || "—"}`
                            : "Pick a type to start"}
                        </div>
                      </div>
                    </div>

                    <div className="si-card">
                      <div className="si-card-h">Summary</div>
                      <div className="si-tot">
                        <div className="si-tr">
                          <span className="l">Lines</span>
                          <span className="v">{fields?.length}</span>
                        </div>
                        <div className="si-tr">
                          <span className="l">Qty</span>
                          <span className="v">{qtyTotal}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="si-actions">
                    <button className="si-btn si-btn--primary" type="submit">
                      <Check />
                      <span>Save</span>
                    </button>
                  </div>
                </aside>
              </div>
            </form>
          </div>
        </div>
        {/* react-select menus portal here so they inherit the .si-term tokens */}
        <div ref={setMenuHost} className="si-menu-host" />
      </div>
    </div>
  );
};
export default StockAdjustmentModal;
